export const errorTypes = [
  'userSessionExpired'
]
